import React, {
  useState,
  useEffect,
} from "react";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Button,
  Grid,
  TablePagination,
  CircularProgress,
  Autocomplete,
  TextField,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import PageContainer from "src/components/container/PageContainer";
import ParentCard from "src/components/shared/ParentCard";
import * as XLSX from "xlsx";
import {
  IconFileDownload,
  IconSearch,
} from "@tabler/icons";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";

import "./style.css";
import ReportService from "src/service/reports";
import moment from "moment";
import VehicleDetailsService from "src/service/vehicleDetails";
import { writeFile } from "xlsx";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

import jsPDF from "jspdf";
import "jspdf-autotable";
import LogoService from "src/service/logoService";
import TimeSlotService from "src/service/timeslot";
import FullscreenDialogforInterest from "src/components/material-ui/dialog/FullscreenDialogforInterest";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Absence Report",
  },
];

const PointofInterestReport = () => {
  const [esclationData, setEsclationData] =
    useState([]);
  const [vehicle_list, setvehicleList] = useState(
    []
  );
  const [selectedVehicle, setSelectedVehicle] =
    useState("");
  const [loading, setLoading] = useState(false);

  const today = new Date()
    .toISOString()
    .split("T")[0];
  const [from_date, setFromDate] =
    useState(today);
  const [to_date, setToDate] = useState(today);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] =
    useState(10);

  const [searchTerm, setSearchTerm] =
    useState("");

  const sessionData = JSON.parse(
    localStorage.getItem("user")
  );
  const [export_data, setExportData] = useState(
    []
  );

  const [logo_data, setLogodata] = useState([]);

  const fetch_logo_data = async () => {
    try {
      const res = await LogoService.getLogoList();
      setLogodata(res.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetch_logo_data();
  }, []);

  useEffect(() => {
    const fetchVehicleNoData = async () => {
      try {
        const res =
          await VehicleDetailsService.fetch_distict_vehicle(
            {
              vehicle_type:
                sessionData?.data?.vehicle_type ||
                "",
              district_id:
                sessionData?.data?.district_id ||
                "",
              user_type:
                sessionData?.data?.user_type ||
                "",
              user_id:
                sessionData?.data?.id || "",
            }
          );
        setvehicleList(res.data);
        // if (res.data.length > 0) {
        //   const defaultVehicle = res.data[0].vehicle_no;
        //   setSelectedVehicle(defaultVehicle);
        //   fetch_geofenc_alert_report(defaultVehicle);
        // }
      } catch (error) {
        console.log(error);
      }
    };

    fetchVehicleNoData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [shift_data, setshift_data] = useState(
    []
  );
  const [
    selected_shift_data,
    setselected_shift_data,
  ] = useState("");

  const [selected_status, setselected_status] =
    useState("");

  const fetch_shift_data = async () => {
    try {
      const res =
        await TimeSlotService.get_slot_data({});
      console.log("res.data", res.data);
      setshift_data(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetch_shift_data();
  }, []);

  const fetch_geofenc_alert_report = async (
    vehicle_no = selectedVehicle
  ) => {
    setLoading(true); // Start loading
    try {
      const res =
        await ReportService.pointOfIntrestReport({
          vehicle_no: vehicle_no,
          from_date: from_date,
          to_date: to_date,
          shift_id: selected_shift_data,
          district_id:
            sessionData?.data?.district_id || "",
          type: 2,
          status: selected_status,
        });
      console.log("final data==", res.data);
      setEsclationData(res.data);
      setExportData(res.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  // Call fetch_geofenc_alert_report when selectedVehicle, from_date, or to_date changes
  useEffect(() => {
    // if (selectedVehicle) {
    fetch_geofenc_alert_report();
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearchClick = () => {
    fetch_geofenc_alert_report(
      selectedVehicle,
      from_date,
      to_date
    );
  };

  const exportVisibleDataToExcel = () => {
    const headers = [
      "Sl. No",
      "Vehicle No",
      "District Name",
      "ERV No",
      "Shift Name",
      "From Time",
      "To Time",
      "Location Name",
      "On Site",
      "DateTime",
    ];

    const data = export_data.map((man, index) => [
      index + 1,
      man?.vehicle_no,
      man?.district_name,
      man?.erv_no !== null &&
      man?.erv_no !== "ABC"
        ? man.erv_no
        : "NA",
      man?.shift_name,
      formatTime(man?.from_time),
      formatTime(man?.to_time),
      man?.location_name,
      man?.status === 1
        ? "Yes"
        : man?.status === 0
        ? "No"
        : "NA",
      man?.datetime !== null
        ? moment(man?.datetime).format(
            "DD-MM-YYYY hh:mm:ss a"
          )
        : "NA",
    ]);

    const exportData = [headers, ...data];

    const ws =
      XLSX.utils.aoa_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      wb,
      ws,
      "Sheet 1"
    );

    const fileName = "Absence Alert Report.xlsx";

    writeFile(wb, fileName);
  };

  const filter_esclationdata =
    esclationData.filter((man) => {
      const status =
        man?.status?.toString() === "1"
          ? "yes"
          : man?.status?.toString() === "0"
          ? "no"
          : "";

      return (
        (man.vehicle_no &&
          man.vehicle_no
            .toLowerCase()
            .includes(
              searchTerm.toLowerCase()
            )) ||
        (man.location_name &&
          man.location_name
            .toLowerCase()
            .includes(
              searchTerm.toLowerCase()
            )) ||
        (man.district_name &&
          man.district_name
            .toLowerCase()
            .includes(
              searchTerm.toLowerCase()
            )) ||
        (man.shift_name &&
          man.shift_name
            .toLowerCase()
            .includes(
              searchTerm.toLowerCase()
            )) ||
        (man.from_time &&
          formatTime(man.from_time).includes(
            searchTerm.toLowerCase()
          )) ||
        (man.to_time &&
          formatTime(man.to_time).includes(
            searchTerm.toLowerCase()
          )) ||
        status
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        (man.datetime &&
          moment(man.datetime)
            .format("DD-MM-YYYY hh:mm:ss a")
            .includes(searchTerm.toLowerCase()))
      );
    });

  const paginatedData =
    filter_esclationdata.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(
      parseInt(event.target.value, 10)
    );
    setPage(0);
  };

  function formatTime(timeStr) {
    // Check if timeStr is empty or null
    if (!timeStr) {
      return "Invalid time"; // or any default value you prefer, e.g., "00:00 AM"
    }

    // Create a new Date object using the given time string
    const [hours, minutes, seconds] =
      timeStr.split(":");
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(seconds);

    // Format hours and minutes with AM/PM
    const options = {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    return date.toLocaleTimeString([], options);
  }

  const exportVisibleDataToPDF = async () => {
    const doc = new jsPDF("landscape");

    const logoUrl = logo_data?.logo; // Bitbucket path to the logo
    let base64Logo = "";

    // Function to fetch and convert image to base64
    function getBase64ImageFromURL(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = url;
        img.onload = () => {
          const canvas =
            document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          const dataURL =
            canvas.toDataURL("image/png");
          resolve(dataURL);
        };
        img.onerror = (error) => {
          reject(error);
        };
      });
    }

    try {
      base64Logo = await getBase64ImageFromURL(
        logoUrl
      );
    } catch (error) {
      console.error(
        "Error fetching the logo image:",
        error
      );
    }

    // First Header Data
    const firstHeader = [
      [
        {
          content: base64Logo
            ? {
                image: base64Logo,
                width: 80,
                height: 30,
              }
            : "",
          colSpan: 2,
          styles: {
            halign: "left",
            valign: "middle",
          },
        },
        {
          content:
            logo_data?.header_name ||
            "Company Name",
          colSpan: 3,
          styles: {
            fontSize: 20,
            valign: "middle",
          },
        },
      ],
    ];

    // Second Header Data
    const headers = [
      "Sl. No",
      "Vehicle No",
      "District Name",
      "ERV No",
      "Shift Name",
      "From Time",
      "To Time",
      "Location Name",
      "On Site",
      "DateTime",
    ];

    const data = esclationData.map(
      (man, index) => [
        index + 1 + page * rowsPerPage,
        man?.vehicle_no,
        man?.district_name,
        man?.erv_no !== null &&
        man?.erv_no !== "ABC"
          ? man.erv_no
          : "NA",
        man?.shift_name,
        formatTime(man?.from_time),
        formatTime(man?.to_time),
        man?.location_name,
        man?.status === 1
          ? "Yes"
          : man?.status === 0
          ? "No"
          : "NA",
        man?.datetime !== null
          ? moment(man?.datetime).format(
              "DD-MM-YYYY hh:mm:ss a"
            )
          : "NA",
      ]
    );

    // Add the first header to the PDF
    doc.autoTable({
      head: firstHeader,
      startY: 20,
      margin: { horizontal: 10 },
      headStyles: { fillColor: [44, 62, 80] },
      styles: { cellPadding: 5, fontSize: 10 },
    });

    // Add the second header (column headers) and the table data to the PDF
    doc.autoTable({
      head: [headers],
      body: data,
      startY: doc.autoTable.previous.finalY, // Start right after the first header
      margin: { horizontal: 10 },
      headStyles: { fillColor: [44, 62, 80] },
      styles: { cellPadding: 5, fontSize: 10 },
    });

    doc.save("Absence Alert Report.pdf");
  };

  // ----------------------------

  return (
    <PageContainer
      title="Absence Report"
      description="this is Basic Table page"
    >
      <Breadcrumb
        title="Absence Report"
        items={BCrumb}
      />

      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            container
            xs={12}
            style={{ paddingBottom: "20px" }}
            alignItems="center"
            spacing={2}
          >
            <Grid
              item
              lg={4}
              md={4}
              sm={6}
              xs={12}
            >
              <CustomFormLabel>
                Vehicle No
              </CustomFormLabel>
              <Autocomplete
                id="vehicle_no"
                name="vehicle_no"
                options={vehicle_list}
                getOptionLabel={(option) =>
                  option.vehicle_no
                }
                value={
                  vehicle_list.find(
                    (option) =>
                      option.vehicle_no ===
                      selectedVehicle
                  ) || null
                }
                onChange={(event, newValue) =>
                  setSelectedVehicle(
                    newValue
                      ? newValue.vehicle_no
                      : ""
                  )
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Select Vehicle No"
                    fullWidth
                  />
                )}
              />
            </Grid>

            <Grid
              item
              lg={4}
              md={4}
              sm={6}
              xs={12}
            >
              <CustomFormLabel>
                Shift Name
              </CustomFormLabel>
              <Autocomplete
                id="shift_id"
                name="shift_id"
                options={shift_data}
                getOptionLabel={(option) =>
                  option.shift_name
                }
                value={
                  shift_data.find(
                    (option) =>
                      option.id ===
                      selected_shift_data
                  ) || null
                }
                onChange={(event, newValue) =>
                  setselected_shift_data(
                    newValue ? newValue.id : ""
                  )
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Select Shift"
                    fullWidth
                  />
                )}
              />
            </Grid>

            <Grid
              item
              lg={4}
              md={6}
              sm={6}
              xs={12}
            >
              <CustomFormLabel htmlFor="status">
                On Site
              </CustomFormLabel>
              <Autocomplete
                id="status"
                name="status"
                options={[
                  {
                    label: "Yes",
                    value: 1,
                  },
                  {
                    label: "No",
                    value: 0,
                  },
                ]}
                getOptionLabel={(option) =>
                  option.label
                }
                value={
                  [
                    {
                      label: "Yes",
                      value: 1,
                    },
                    {
                      label: "No",
                      value: 0,
                    },
                  ].find(
                    (option) =>
                      option.value ===
                      selected_status
                  ) || null
                }
                onChange={(event, newValue) =>
                  setselected_status(
                    newValue ? newValue.value : ""
                  )
                }
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    fullWidth
                    variant="outlined"
                    placeholder="Select Present Or Absent"
                  />
                )}
              />
            </Grid>

            <Grid
              item
              lg={3}
              md={4}
              sm={6}
              xs={12}
            >
              <CustomFormLabel htmlFor="from_date">
                From Date
              </CustomFormLabel>
              <CustomTextField
                id="from_date"
                name="from_date"
                type="date"
                value={from_date}
                onChange={(e) =>
                  setFromDate(e.target.value)
                }
                variant="outlined"
                fullWidth
              />
            </Grid>
            <Grid
              item
              lg={3}
              md={4}
              sm={6}
              xs={12}
            >
              <CustomFormLabel htmlFor="to_date">
                To Date
              </CustomFormLabel>
              <CustomTextField
                id="to_date"
                name="to_date"
                type="date"
                value={to_date}
                onChange={(e) =>
                  setToDate(e.target.value)
                }
                variant="outlined"
                fullWidth
              />
            </Grid>

            <Grid
              item
              lg={3}
              md={4}
              sm={6}
              xs={12}
            >
              <CustomFormLabel>
                Search
              </CustomFormLabel>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconSearch />
                    </InputAdornment>
                  ),
                }}
                placeholder="search"
                value={searchTerm}
                onChange={(e) =>
                  setSearchTerm(e.target.value)
                }
              />
            </Grid>

            <Grid
              item
              lg={1}
              md={2}
              sm={4}
              xs={6}
              style={{ marginTop: "30px" }}
            >
              <Button
                onClick={handleSearchClick}
                style={{ padding: "10px" }}
              >
                <IconSearch />
              </Button>
            </Grid>
            <Grid
              item
              lg={1}
              md={2}
              sm={4}
              xs={6}
              style={{ marginTop: "30px" }}
            >
              <Button
                variant="contained"
                color="success"
                onClick={exportVisibleDataToExcel}
                style={{ padding: "10px" }}
              >
                <IconFileDownload width={20} />
              </Button>
            </Grid>
            <Grid
              item
              lg={1}
              md={2}
              sm={4}
              xs={6}
              style={{ marginTop: "30px" }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={exportVisibleDataToPDF}
                style={{ padding: "10px" }}
              >
                <PictureAsPdfIcon />
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Paper variant="outlined">
          <TableContainer>
            <Table
              id="allotment_report_table"
              aria-label="simple table"
              sx={{
                whiteSpace: "",
              }}
            >
              <TableHead
                style={{
                  backgroundColor: "silver",
                }}
              >
                <TableRow>
                  <TableCell colSpan={2}>
                    <img
                      src={logo_data?.logo}
                      alt=""
                      width={80}
                    />
                  </TableCell>
                  <TableCell colSpan={13}>
                    <Typography
                      style={{
                        fontSize: "20px",
                        textAlign: "center",
                      }}
                      variant="h5"
                    >
                      {logo_data?.header_name}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableHead
                style={{
                  backgroundColor: "silver",
                }}
              >
                <TableRow>
                  <TableCell>
                    <Typography
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      variant="h6"
                    >
                      Sl. No
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      variant="h6"
                    >
                      Vehicle No
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      variant="h6"
                    >
                      District Name
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      variant="h6"
                    >
                      ERV No
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      variant="h6"
                    >
                      Shift Name
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      variant="h6"
                    >
                      From Time
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      variant="h6"
                    >
                      To Time
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      variant="h6"
                    >
                      Location Name
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      variant="h6"
                    >
                      On Site
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      variant="h6"
                    >
                      Date
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      variant="h6"
                    >
                      Location
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell
                      colSpan={12}
                      style={{
                        textAlign: "center",
                      }}
                    >
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : paginatedData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={12}>
                      <Typography
                        style={{
                          fontSize: "14px",
                          textAlign: "center",
                          color: "red",
                        }}
                        variant="h6"
                      >
                        No records found
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  paginatedData.map(
                    (item, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          <Typography
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                            }}
                            variant="h6"
                          >
                            {index +
                              1 +
                              page * rowsPerPage}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          <Typography
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                            }}
                            variant="h6"
                          >
                            {item?.vehicle_no !==
                            null
                              ? item?.vehicle_no
                              : "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                            }}
                            variant="h6"
                          >
                            {item?.district_name !==
                            null
                              ? item?.district_name
                              : "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                            }}
                            variant="h6"
                          >
                            {item?.erv_no !==
                              null &&
                            item?.erv_no !== "ABC"
                              ? item.erv_no
                              : "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                            }}
                            variant="h6"
                          >
                            {item?.shift_name !==
                            null
                              ? item?.shift_name
                              : "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                            }}
                            variant="h6"
                          >
                            {item?.from_time !==
                            null
                              ? formatTime(
                                  item?.from_time
                                )
                              : "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                            }}
                            variant="h6"
                          >
                            {item?.to_time !==
                            null
                              ? formatTime(
                                  item?.to_time
                                )
                              : "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                              textTransform:
                                "uppercase",
                            }}
                            variant="h6"
                          >
                            <Tooltip
                              title={
                                item?.location_name
                              }
                              placement="top"
                              arrow
                            >
                              {item?.location_name !==
                              null
                                ? item
                                    .location_name
                                    .length > 20
                                  ? `${item.location_name.substring(
                                      0,
                                      20
                                    )}...`
                                  : item.location_name
                                : "NA"}
                            </Tooltip>
                          </Typography>
                        </TableCell>

                        <TableCell>
                          <Typography
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                            }}
                            variant="h6"
                          >
                            {item?.status === 1
                              ? "Yes"
                              : item?.status === 0
                              ? "No"
                              : "NA"}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          <Typography
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                            }}
                            variant="h6"
                          >
                            {item?.datetime !==
                            null
                              ? moment(
                                  item?.datetime
                                ).format(
                                  "DD-MM-YYYY"
                                )
                              : "NA"}
                          </Typography>
                        </TableCell>

                        <TableCell
                          style={{
                            textAlign: "center",
                          }}
                        >
                          <Typography
                            style={{
                              fontSize: "14px",
                            }}
                            variant="h6"
                          >
                            <FullscreenDialogforInterest
                              id={item?.id}
                              radialCoordinates={{
                                lat: item?.location_lat,
                                lng: item?.location_lng,
                              }}
                              radius={
                                item?.radius
                              }
                              markerCoordinates={{
                                lat: item?.lat,
                                lng: item?.lng,
                              }}
                              locationName={
                                item?.location_name
                              }
                              datetime={
                                item?.datetime
                              }
                              status={
                                item?.status === 0
                                  ? "No"
                                  : item?.status ===
                                    1
                                  ? "Yes"
                                  : "NA"
                              }
                            />
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[
              10, 25, 50, 100, 250, 500,
            ]}
            component="div"
            count={esclationData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={
              handleChangeRowsPerPage
            }
          />
        </Paper>
      </ParentCard>
    </PageContainer>
  );
};

export default PointofInterestReport;
